import React, { useMemo } from 'react'
import { Typography, Grid } from '@mui/material'
import TableTemplate from '../../Common/Table/TableTemplate'
import { setDateFormat, setTimeFormat } from '../../../utils/dateUtils'
import { fontSizes, fontWeights } from '../../Common/Typography/TypographyStyles'
import { Task } from '../../../redux/task/types'
import ViewAssignedTeamMembers from './ViewAssignedTeamMembers'
import { useAppSelector } from '../../../redux/store'
import {
  selectEventsError,
  selectEventsLoading,
  selectFilteredEventsIsNotArchived,
} from '../../../redux/event/manageEvents/selector'

interface Column {
  field: string
  headerName: string
  headerAlign?: 'left' | 'right' | 'center'
  bodyAlignment?: 'center' | 'right' | 'left'
  width?: string | number
  renderCell?: (value: any, item: any) => React.ReactNode
  renderFormat?: (value: any) => React.ReactNode
  sortable: boolean
}

const TaskTable: React.FC = () => {
  const eventData = useAppSelector(selectFilteredEventsIsNotArchived)
  const loading = useAppSelector(selectEventsLoading)
  const error = useAppSelector(selectEventsError)

  const columns = useMemo<Column[]>(
    () => [
      {
        field: 'id',
        headerName: 'TASK ID',
        bodyAlignment: 'center',
        sortable: true,
      },
      {
        field: 'title',
        headerName: 'TITLE',
        bodyAlignment: 'center',
        sortable: true,
        renderCell: (param: string) => (
          <Typography
            sx={{
              maxWidth: 200,
              whiteSpace: 'normal',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              textAlign: 'left',
              display: 'block',
              margin: '0 auto',
              fontSize: fontSizes.size12,
              fontWeight: fontWeights[700],
            }}
          >
            {param}
          </Typography>
        ),
      },
      {
        field: 'createdAt',
        headerName: 'CREATED DATE',
        bodyAlignment: 'center',
        sortable: true,
        renderFormat: (value: string) => (
          <Grid container spacing={0} direction='column' alignContent='center'>
            <Grid>
              <Typography
                sx={{
                  fontSize: fontSizes.size12,
                  weight: fontSizes[700],
                  lineHeight: 'ratio9to8',
                  letterSpacing: 'loose',
                }}
              >
                {setDateFormat(value)}
              </Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{
                  fontSize: fontSizes.size12,
                  lineHeight: 'ratio9to8',
                  letterSpacing: 'loose',
                }}
              >
                {setTimeFormat(value)}
              </Typography>
            </Grid>
          </Grid>
        ),
      },
      {
        field: 'id',
        headerName: 'ACTION',
        bodyAlignment: 'center',
        sortable: false,
        renderCell: (_id: number, row: Task) => <ViewAssignedTeamMembers taskDetails={row} />,
      },
    ],
    [],
  )

  return (
    <React.Fragment>
      <TableTemplate columns={columns} datas={eventData} state={[loading, error]} uniqueField='id' />
    </React.Fragment>
  )
}

export default TaskTable
